import { SessionUser } from 'model/userSession';
import { ApiEnvelope, DsEntry, apiClient, authHeaders } from 'service/apiClient';

export type { DsEntry };

const fileBrowserSettingsApi = {
  dsLs(path: string) {
    return apiClient.post<ApiEnvelope<DsEntry[]>>('/ds/ls', { path }, authHeaders());
  },

  setupHome(homePath: string) {
    return apiClient.post<ApiEnvelope<SessionUser>>('/auth/setup-home', { homePath }, authHeaders());
  },
};

export default fileBrowserSettingsApi;
